import api from "../api/client";
const options = {
  baseEndpoint: "api/v1/OtherForms",
  data: {},
};
export default {
  GetPowerApps(token, data) {
    options.token = token;
    options.data = data;
    options.endpoint = `${options.baseEndpoint}/ListPowerApps`;
    return api.post(options);
  },
};
